import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';
import './index.css';

const NotFound = ({ loggedInUser, onLogout }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 200px)', // 减去头部和页脚的大致高度
      width: '100%',
      padding: '20px'
    }}>
      <Result
        status="404"
        title="404"
        subTitle="抱歉，您访问的页面不存在。"
        extra={
          <Link to="/">
            <Button type="primary">返回首页</Button>
          </Link>
        }
      />
    </div>
  );
};

export default NotFound;